import React, { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PackageIcon } from 'lucide-react';
import { families, products } from '../data/products';
import { ProductFamily } from '../types/catalog';
import { ProductCard } from '../components/ProductCard';
type Filter = ProductFamily | 'tout';
type SortKey = 'nouveautes' | 'prix-asc' | 'prix-desc';
const sorts: {
  id: SortKey;
  label: string;
}[] = [{
  id: 'nouveautes',
  label: 'Sélection de la ferme'
}, {
  id: 'prix-asc',
  label: 'Prix croissant'
}, {
  id: 'prix-desc',
  label: 'Prix décroissant'
}];
export function Boutique() {
  const [searchParams, setSearchParams] = useSearchParams();
  const familyParam = searchParams.get('famille') as Filter | null;
  const filter: Filter = familyParam && families.some(family => family.id === familyParam) ? familyParam : 'tout';
  const [sort, setSort] = useState<SortKey>('nouveautes');
  const visible = useMemo(() => {
    const list = filter === 'tout' ? products : products.filter(item => item.family === filter);
    if (sort === 'prix-asc') return [...list].sort((a, b) => a.price - b.price);
    if (sort === 'prix-desc') return [...list].sort((a, b) => b.price - a.price);
    return list;
  }, [filter, sort]);
  const activeFamily = families.find(family => family.id === filter);
  const setFilter = (value: Filter) => {
    setSearchParams(value === 'tout' ? {} : {
      famille: value
    });
  };
  return <div className="mx-auto max-w-page px-5 py-14 lg:px-8" data-id="element-119" data-mp="1gzhq6oifn67v">
      <header className="max-w-2xl" data-id="element-120" data-mp="1lykkbdwvjs12">
        <h1 className="font-display text-4xl leading-tight text-ink sm:text-5xl" data-id="element-121" data-mp="1lxjbzh78tjn1">Boutique</h1>
        <p className="mt-4 text-base leading-relaxed text-muted" data-id="element-122" data-mp="178n4pmd0ganh">
          {activeFamily ? activeFamily.blurb : 'Tout ce qui sort de la ferme : laine mérinos filée en Aveyron, tricots en mohair et savons saponifiés à froid. Expédition sous 3 jours ouvrés.'}
        </p>
      </header>

      <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-b border-line pb-4" data-id="element-123" data-mp="24pv8vof4nsps">
        <div className="flex flex-wrap gap-2" role="tablist" aria-label="Familles de produits" data-id="element-124" data-mp="2eigbjzttve8t">
          {(['tout', ...families.map(family => family.id)] as Filter[]).map(value => {
          const label = value === 'tout' ? 'Tout' : families.find(f => f.id === value)?.label;
          const isActive = filter === value;
          return <button key={value} type="button" role="tab" aria-selected={isActive} onClick={() => setFilter(value)} className={`rounded-full px-4 py-2 text-sm transition-colors duration-150 ease-soft ${isActive ? 'bg-ink text-cream' : 'border border-line text-muted hover:border-ink hover:text-ink'}`} data-id="element-125" data-mp="1vlyed2w7mm56">
                {label}
              </button>;
        })}
        </div>

        <label className="flex items-center gap-2 text-sm text-muted" data-id="element-126" data-mp="3jjplh85vgwri">
          Trier
          <select value={sort} onChange={event => setSort(event.target.value as SortKey)} className="rounded-full border border-line bg-cream px-3 py-2 text-sm text-ink focus:border-olive focus:outline-none" data-id="element-127" data-mp="3oiiog6nj95df">
            {sorts.map(option => <option key={option.id} value={option.id} data-id="element-128" data-mp="30sy71s712g69">
                {option.label}
              </option>)}
          </select>
        </label>
      </div>

      <p className="mt-4 text-sm text-muted" data-id="element-129" data-mp="34ut42khxe7e8">
        {visible.length} article{visible.length > 1 ? 's' : ''}
      </p>

      {visible.length === 0 ? <div className="mt-16 flex flex-col items-center gap-3 text-center" data-id="element-130" data-mp="3ekmgtott0sk2">
          <PackageIcon className="h-8 w-8 text-line" aria-hidden="true" data-id="element-131" data-mp="2h4yxgko79f2f" />
          <p className="font-display text-lg text-ink" data-id="element-132" data-mp="2h2w4psvnx7u0">Rien dans cette famille pour le moment</p>
          <p className="max-w-sm text-sm text-muted" data-id="element-133" data-mp="2m1z16oxku5qd">
            La prochaine tonte arrive au printemps — écrivez-nous pour être prévenu.
          </p>
        </div> : <div className="mt-8 grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-134" data-mp="nnt5r9c6u2u9">
          {visible.map(product => <ProductCard key={product.id} product={product} data-id="element-135" data-mp="11fr8n2fb32hz" />)}
        </div>}
    </div>;
}